import styled from "styled-components";
import { Card, Collapse, Typography } from "antd";

export const ProfileCardStyled = styled(Card)`
  && {
    border: 1px solid ${(p) => p.theme?.colors?.border ?? "#D8DAE5"};
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  }
`;

export const InsightsCollapseStyled = styled(Collapse)`
  && {
    background: transparent;
    border: none;

    .ant-collapse-item {
      border-bottom: 1px solid ${(p) => p.theme?.colors?.border ?? "#E8EAF0"};
      &:last-child {
        border-bottom: none;
      }
    }

    .ant-collapse-header {
      padding: 8px 0 !important;
      font-size: 12px;
      font-weight: 600;
      color: ${(p) => p.theme?.colors?.primary ?? "#00827F"};
    }

    .ant-collapse-content-box {
      padding: 0 0 10px 0 !important;
      font-size: 12px;
      line-height: 1.7;
      color: ${(p) => p.theme?.colors?.text ?? "#333"};
    }

    .ant-collapse-arrow {
      font-size: 10px !important;
    }
  }
`;

export const ProfileLabelStyled = styled(Typography.Text)`
  && {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-transform: uppercase;
  }
`;

export const ProfileBodyStyled = styled(Typography.Text)`
  && {
    font-size: 13px;
    line-height: 1.7;
    display: block;
    ${(p) => p.$centered && "text-align: center;"}
  }
`;
